import React from "react";
import { makeStyles, Paper, Typography, Chip } from "@material-ui/core";
import { i18n } from "../../../translate/i18n";
import InfoTip from "./InfoTip";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2) },
  title: { marginBottom: theme.spacing(1), fontWeight: 600 },
  empty: { color: "#888", fontSize: 14 },
}));

const ObjetoReclamoPanel = ({ stats, isTV = false }) => {
  const classes = useStyles();
  const items = stats?.objetoReclamoBreakdown ?? [];

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.kpis.objetoReclamo")}
        <InfoTip tipKey="objetoReclamo" isTV={isTV} />
      </Typography>
      {items.length === 0 ? (
        <div className={classes.empty}>
          {i18n.t("aiAssistantStats.empty.noObjeto")}
        </div>
      ) : (
        items.map((o, i) => (
          <Chip
            key={i}
            size="small"
            label={`${o.objeto ?? "?"} (${o.count ?? 0})`}
            style={{ margin: 3 }}
          />
        ))
      )}
    </Paper>
  );
};

export default ObjetoReclamoPanel;
